import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-language-square',
  standalone: true,
  templateUrl: '../../assets/language-square.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamLanguageSquareIcon {}
